import{S as o,d as s}from"./shopping-cart-view2.js";const p=o,r=s;export{p as ShoppingCartView,r as defineCustomElement}